var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessintli(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.625 5.625H9.375C7.3125 5.625 5.625 7.3125 5.625 9.375V35.625C5.625 37.6875 7.3125 39.375 9.375 39.375H35.625C37.6875 39.375 39.375 37.6875 39.375 35.625V9.375C39.375 7.3125 37.6875 5.625 35.625 5.625ZM15 31.875C13.9688 31.875 13.125 31.0312 13.125 30V24.375C13.125 23.3438 13.9688 22.5 15 22.5C16.0312 22.5 16.875 23.3438 16.875 24.375V30C16.875 31.0312 16.0312 31.875 15 31.875ZM22.5 31.875C21.4688 31.875 20.625 31.0312 20.625 30V28.125C20.625 27.0938 21.4688 26.25 22.5 26.25C23.5312 26.25 24.375 27.0938 24.375 28.125V30C24.375 31.0312 23.5312 31.875 22.5 31.875ZM22.5 22.5C21.4688 22.5 20.625 21.6562 20.625 20.625C20.625 19.5938 21.4688 18.75 22.5 18.75C23.5312 18.75 24.375 19.5938 24.375 20.625C24.375 21.6562 23.5312 22.5 22.5 22.5ZM30 31.875C28.9688 31.875 28.125 31.0312 28.125 30V15C28.125 13.9688 28.9688 13.125 30 13.125C31.0312 13.125 31.875 13.9688 31.875 15V30C31.875 31.0312 31.0312 31.875 30 31.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessintli);
export default __webpack_public_path__ + "static/media/businessintli.66749168495910cd4c62848e7cec232b.svg";
export { ForwardRef as ReactComponent };